import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/HeaderFooterSidebar.css';

const routeTitles = {
  '/': 'Legacy Motors',
  '/who': 'Who We Are',
  '/dev': 'Development',
  '/careers': 'Careers',
  '/parts': 'Parts',
  '/offers': 'Active Offers',
  '/quote': 'Request a Quote',
  '/buildnprice': 'Build & Price',
  '/signup': 'Sign Up',
  '/not-authorized': 'Not Authorized',
  '/profile': 'Profile',
  '/contact-us': 'Contact Us',
  // Add more routes as needed
};

function getTitle(pathname) {
  // Handle dynamic routes like /vehicles/:id
  if (pathname.startsWith('/vehicles/')) return 'Vehicle Details';
  if (pathname.startsWith('/edit-')) return 'Admin Edit';
  return routeTitles[pathname] || 'Legacy Motors';
}

const Header = () => {
  const location = useLocation();
  const title = getTitle(location.pathname);

  return (
    <header className="page-header">
      <h1>{title}</h1>
    </header>
  );
};

export default Header;